export enum Product {
  DIAGNOSIS = 'diagnosis',
  SCANNER = 'scanner',
  REPORT = 'report',
  APPOINTMENT = 'appointment',
  COLLECT = 'collect',
  WORKSHOPS = 'workshops',
  UNKNOWN = 'unknown'
}
